import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import { OnlineStatus } from './Component/OnlineStatus';
import OfflineBanner from './Component/OfflineBanner';



// Home Components
import Home from './home/Home';
import Navbar from './home/Navbar';

// Syllabus
import Syllabus from './Books/Syllabus/Syllabus';
import SyllabusPhy from './Books/Syllabus/Subjects/SyllabusPhy';
import SyllabusChem from './Books/Syllabus/Subjects/SyllabusChe';
import SyllabusMath from './Books/Syllabus/Subjects/SyllabusMath';

// Quiz Components
import QuizStarting from './MockTest/QuizStarting';
import QuizDetailsPage from './MockTest/QuizDetailsPage';

import PageNotFound from './Pages/PageNotFound';

import QuizReStarting from './MockTest/QuizReStarting';

import Bottombar from './home/Bottombar';
import About from './Pages/About';
import Contact from './Pages/Contact';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Footer from './home/Footer';
import PDFViewer from './Books/PDFViwer';
import MoreOptions from './home/MoreOptions';


import OnlineReadBook from './Books/OnlineReadBook';

import QuestionSolution from './Practics/QuestionSolution';

import ChapterWiseWeightage from './Pages/ChapterWiseWeightage/ChapterWiseWeightage';
import ChapterWiseWeightagePhysTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightagePhysTopics';
import ChapterWiseWeightageChemTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageChemTopics';
import ChapterWiseWeightageMathTopics from './Pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageMathTopics';

import StudyPlanner from './Pages/StudyPlanner';
import StudyTimeTable from './Pages/StudyTimeTable';

import PYQMockTest from './MockTest/PYQMockTest/PYQMockTestSubject';
import PYQMockTestYear from './MockTest/PYQMockTest/PYQMockTestYear';
import PYQMTStartDetails from './MockTest/PYQMTStartDetails';
import BookmarkedQuestions from './Practics/BookMarkedQuestions';
import BookmarkedPdfs from './Books/BookMarkedPdfs';
import FormulaPhysTopics from './Books/Formula/Subjects/FormulaPhysTopics';
import FormulaChemTopics from './Books/Formula/Subjects/FormulaChemTopics';
import FormulaMathTopics from './Books/Formula/Subjects/FormulaMathTopics';
import Formula from './Books/Formula/Formula';
import RepeatedPYQ from './Books/RepeatedPYQ/RepeatedPYQ';
import RepeatedPYQPhysTopics from './Books/RepeatedPYQ/Subjects/RepeatedPYQPhysTopics';
import RepeatedPYQChemTopics from './Books/RepeatedPYQ/Subjects/RepeatedPYQChemTopics';
import RepeatedPYQMathTopics from './Books/RepeatedPYQ/Subjects/RepeatedPYQMathTopics';
import Mnemonic from './Books/Mnemonic/Mnemonic';
import MnemonicPhysTopics from './Books/Mnemonic/Subjects/MnemonicPhysTopics';
import MnemonicChemTopics from './Books/Mnemonic/Subjects/MnemonicChemTopics';
import MnemonicMathTopics from './Books/Mnemonic/Subjects/MnemonicMathTopics';
import Flashcard from './Books/Flashcard/Flashcard';
import FlashcardPhysTopics from './Books/Flashcard/Subjects/FlashcardPhysTopics';
import FlashcardChemTopics from './Books/Flashcard/Subjects/FlashcardChemTopics';
import FlashcardMathTopics from './Books/Flashcard/Subjects/FlashcardMathTopics';
import MindMap from './Books/MindMap/MindMap';
import MindMapPhysTopics from './Books/MindMap/Subjects/MindMapPhysTopics';
import MindMapChemTopics from './Books/MindMap/Subjects/MindMapChemTopics';
import MindMapMathTopics from './Books/MindMap/Subjects/MindMapMathTopics';
import TopperNote from './Books/TopperNote/TopperNote';
import TopperNotePhysTopics from './Books/TopperNote/Subjects/TopperNotePhysTopics';
import TopperNoteChemTopics from './Books/TopperNote/Subjects/TopperNoteChemTopics';
import TopperNoteMathTopics from './Books/TopperNote/Subjects/TopperNoteMathTopics';
import NcertBooks from './Books/NcertBook/NcertBooks';
import NcertBookMathTopics from './Books/NcertBook/Subjects/NcertBookMathTopics';
import NcertBookPhyTopics from './Books/NcertBook/Subjects/NcertBookPhyTopics';
import NcertBookCheTopics from './Books/NcertBook/Subjects/NcertBookCheTopics';
import ChapterWisePYQ from './Books/ChapterWisePYQ/ChapterWisePYQ';
import ChapterWisePYQPhyTopics from './Books/ChapterWisePYQ/Subjects/ChapterWisePYQPhyTopics';
import ChapterWisePYQCheTopics from './Books/ChapterWisePYQ/Subjects/ChapterWisePYQCheTopics';
import ChapterWisePYQMathTopics from './Books/ChapterWisePYQ/Subjects/ChapterWisePYQMathTopics';
import SubjectPage from './Subjects/SubjectPage';


const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const location = useLocation();

  const isOnline = OnlineStatus();


  return (
    <>


      {!isOnline && (<OfflineBanner />)}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        <Navbar />}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/pdfviewer') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        !location.pathname.startsWith('/account-deletion') &&
        <Bottombar />}

      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/subject" element={<SubjectPage />} />


        <Route path="/more-options" element={<MoreOptions />} />

        <Route path="/pdfviewer/:id" element={<PDFViewer />} />
        <Route path="/onlinereadbook/:type/:subject/:topic" element={<OnlineReadBook />} />
        <Route path="/question-solution/:id" element={<QuestionSolution />} />
        <Route path="/bookmarked-questions" element={<BookmarkedQuestions />} />
        <Route path="/bookmarked-pdfs" element={<BookmarkedPdfs />} />


        {/* PYQ Quiz Routes */}
        <Route path="/pyq-mock-test" element={<PYQMockTest />} />
        <Route path="/pyq-mock-test/:type/:subject/:subjectName" element={<PYQMockTestYear />} />

        <Route path="/quiz-starting/:quizId/:type/:subject/:subjectName" element={<QuizStarting />} />
        <Route path="/quiz-restarting/:quizId" element={<QuizReStarting />} />
        <Route path="/quiz-details/:quizId" element={<QuizDetailsPage />} />
        <Route path="/pyq-mock-test-start-details/:quizId/:type/:subject/:subjectName" element={<PYQMTStartDetails />} />

        {/* Syllabus Routes */}
        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/syllabus/physics" element={<SyllabusPhy />} />
        <Route path="/syllabus/chemistry" element={<SyllabusChem />} />
        <Route path="/syllabus/mathematics" element={<SyllabusMath />} />

        {/* NCERT BOOK */}
        <Route path="/ncert-book" element={<NcertBooks />} />
        <Route path="/ncert-book/physics" element={<NcertBookPhyTopics />} />
        <Route path="/ncert-book/chemistry" element={<NcertBookCheTopics />} />
        <Route path="/ncert-book/mathematics" element={<NcertBookMathTopics />} />

                {/* Chapter wise PYQ */}
        <Route path="/chapter-wise-pyq" element={<ChapterWisePYQ />} />
        <Route path="/chapter-wise-pyq/physics" element={<ChapterWisePYQPhyTopics />} />
        <Route path="/chapter-wise-pyq/chemistry" element={<ChapterWisePYQCheTopics />} />
        <Route path="/chapter-wise-pyq/mathematics" element={<ChapterWisePYQMathTopics />} />


        {/* Formula */}
        <Route path="/formula" element={<Formula />} />
        <Route path="/formula/physics" element={<FormulaPhysTopics />} />
        <Route path="/formula/chemistry" element={<FormulaChemTopics />} />
        <Route path="/formula/mathematics" element={<FormulaMathTopics />} />

        {/* Mnemonics */}
        <Route path="/mnemonic" element={<Mnemonic />} />
        <Route path="/mnemonic/physics" element={<MnemonicPhysTopics />} />
        <Route path="/mnemonic/chemistry" element={<MnemonicChemTopics />} />
        <Route path="/mnemonic/mathematics" element={<MnemonicMathTopics />} />

                {/* Formula */}
        <Route path="/flashcard" element={<Flashcard />} />
        <Route path="/flashcard/physics" element={<FlashcardPhysTopics />} />
        <Route path="/flashcard/chemistry" element={<FlashcardChemTopics />} />
        <Route path="/flashcard/mathematics" element={<FlashcardMathTopics />} />

        {/* Formula */}
        <Route path="/mindmap" element={<MindMap />} />
        <Route path="/mindmap/physics" element={<MindMapPhysTopics />} />
        <Route path="/mindmap/chemistry" element={<MindMapChemTopics />} />
        <Route path="/mindmap/mathematics" element={<MindMapMathTopics />} />

        {/* Formula */}
        <Route path="/toppernote" element={<TopperNote />} />
        <Route path="/toppernote/physics" element={<TopperNotePhysTopics />} />
        <Route path="/toppernote/chemistry" element={<TopperNoteChemTopics />} />
        <Route path="/toppernote/mathematics" element={<TopperNoteMathTopics />} />


        {/* Top important PYQ */}
        <Route path="/repeated-pyq" element={<RepeatedPYQ />} />
        <Route path="/repeated-pyq/physics" element={<RepeatedPYQPhysTopics />} />
        <Route path="/repeated-pyq/chemistry" element={<RepeatedPYQChemTopics />} />
        <Route path="/repeated-pyq/mathematics" element={<RepeatedPYQMathTopics />} />

        {/* Chapter Weightage Routes */}
        <Route path="/chapter-wise-weightage" element={<ChapterWiseWeightage />} />
        <Route path="/chapter-wise-weightage/physics" element={<ChapterWiseWeightagePhysTopics />} />
        <Route path="/chapter-wise-weightage/chemistry" element={<ChapterWiseWeightageChemTopics />} />
        <Route path="/chapter-wise-weightage/mathematics" element={<ChapterWiseWeightageMathTopics />} />

        {/* Study Planner Routes */}
        <Route path="/jee-main-study-planner" element={<StudyPlanner />} />
        <Route path="/jee-main-study-time-table" element={<StudyTimeTable />} />

        {/* 404 Route */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        <Footer />}
    </>
  );
};

export default App;